import { Flex, Space, Typography, Dropdown, Avatar, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { UserOutlined, MenuOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { UserAuth } from '../../../middleware/UserContext/UserContext.middleware';
import { useIsMobile } from '../../../services/responsiveUtils';
import { useMenuNavigation, useMenuItems } from '../Sidebar/Sidebar.component';
import { useTranslation } from 'react-i18next';
import './CustomHeader.styles.css';

const CustomHeader: React.FC = () => {
  const { currentUser, logout } = UserAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { handleMenuClick } = useMenuNavigation();
  const menuItems = useMenuItems();
  const [menuVisible, setMenuVisible] = useState(false);
  const { t } = useTranslation();

  const handleLogoOnClick = () => {
    navigate('/');
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const userMenuItems = [
    {
      key: 'logout',
      label: t('logout', { ns: 'auth' }),
      onClick: logout,
    },
  ];

  return (
    <Flex vertical className="header">
      <Flex justify="space-between" align="center" style={{ padding: '0 24px' }}>
        <div>
          {(isMobile && currentUser) && (
            <Dropdown
              menu={{
                items: currentUser && menuItems,
                onClick: handleMenuClick,
              }}
              trigger={['click']}
              open={menuVisible}
              onOpenChange={setMenuVisible}
            >
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={toggleMenu}
                className="mobile-menu-btn"
              />
            </Dropdown>
          )}
          <Typography.Title level={3} type="secondary" style={{ cursor: 'pointer', display: 'inline-block', marginLeft: '16px' }} onClick={handleLogoOnClick}>
            Advertizer
          </Typography.Title>
        </div>
        {currentUser && (
          <Dropdown menu={{ items: userMenuItems }}>
            <Space size="middle">
              <Avatar icon={<UserOutlined />} />
              <Typography.Title level={5} className="email-text">
                {currentUser.email}
              </Typography.Title>
            </Space>
          </Dropdown>
        )}
      </Flex>
    </Flex>
  );
};

export default CustomHeader;